import * as React from 'react';
import { cn } from '../lib/utils';

export function FormGrid({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('grid gap-[var(--space-grid)] md:grid-cols-2', className)}
      {...props}
    />
  );
}

export function FormRow({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('flex flex-col gap-[var(--space-grid)] md:flex-row', className)} {...props} />;
}
